import GLightbox from 'glightbox';

let lightbox;

function setupLightbox() {
  // Create a lightbox instance
  // eslint-disable-next-line no-unused-vars
  lightbox = GLightbox({
    selector: '.glightbox, [data-lity]',
    touchNavigation: true,
    autoplayVideos: true,
  });
}

function destroyLightbox() {
  if (lightbox) {
    lightbox.destroy();
  }
}

export default {
  init() {
    setupLightbox();
  },
  unload() {
    destroyLightbox();
  },
  reload() {
    setupLightbox();
  },
};
